var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOnesSuperior = function SvgOnesSuperior(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 720,
    height: 333,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "ones_superior_svg__a",
    width: 720,
    height: 333,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d9",
    d: "M0 0h720v333H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#18c6b5",
    mask: "url(#ones_superior_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-9.626.246C82.918 10.844 169.33 46.13 185.273 146.461c8.292 52.193 12.331 116.821 54.533 154.745 79.726 71.63 225.197.145 295.23-51.613 41.152-30.418 80.511-64.098 126.505-86.549 45.994-22.45 100.981-32.612 148.426-13.424.291-49.785.205-99.58.205-149.365H-9.626z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-90 .246S-69.266 86.342 38.034 74.78c107.291-11.563 287.937-30.384 388.439 82.714 85.523 96.241 209.706 220.636 383.699 153.592V.246z",
    opacity: 0.5
  }))));
};
export { SvgOnesSuperior as ReactComponent };